var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout"},[_c('header',[_c('router-link',{attrs:{"to":{ path: '/' }}},[_c('div',{staticClass:"header logo"},[_c('img',{attrs:{"alt":"Vue logo","src":require("../assets/truecaller.svg")}})])])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }